import Vue from "vue"
import type { ResultData } from "~/types/axios";

const CONFIG_API = {
    // 游轮详情
    cruiseInfo: '/product/product/abroad-cruise-info',
    cruiseDate:'/product/product/abroad-cruise-date',
    index: '/product/product/purchase-index',
    countryMobileCode: '/conf/country-mobile-code',
    countryName: '/conf/country-name',

    cabinPrices: '/auto/cruise-auto/cabin-prices',

    cabinDecks: '/auto/cruise-auto/cabin-decks'
}

// 产品详情 https://www.apifox.cn/web/project/1407556/apis/api-41620107
export function getAbroadCruiseInfo(data: any) {
    return Vue.$axios.$post(CONFIG_API.cruiseInfo, { data })
}

// 产品团期 https://www.apifox.cn/web/project/1407556/apis/api-41931106
export function getAbroadCruiseDate(data: any) {
    return Vue.$axios.$post(CONFIG_API.cruiseDate, {data})
}

// 舱房价格 /auto/cruise-auto/cabin-prices
export function getCabinPrices(data: any) {
    return Vue.$axios.$post(CONFIG_API.cabinPrices, {data}, {
        baseURL: process.env.API_HOST,
        timeout: 10000 * 90
    })
}

export function getProductIndex(){
    return Vue.$axios.$post(CONFIG_API.index)
}
/**
 * @desc 获取国家电话代码
 * @link https://www.apifox.cn/web/project/1407556/apis/api-42358352
 * @returns {Array<string>}
 */
export function getCountryMobileCode() {
    return Vue.$axios.$get<ResultData<string[]>>(CONFIG_API.countryMobileCode)
}

/**
 * @desc 获取国家名称
 * @link https://www.apifox.cn/web/project/1407556/apis/api-42358324
 * @returns {Array<string>}
 */
export function getCountryName() {
    return Vue.$axios.$get(CONFIG_API.countryName)
}

/**
 * @desc 获取甲板
 * @link https://www.apifox.cn/web/project/1407556/apis/api-65161676
 * @returns {Array<{}>}
 */
export function getCabinDecks(data: any) {
    return Vue.$axios.$post(CONFIG_API.cabinDecks, {data}, {
        baseURL: process.env.API_HOST,
        timeout: 10000 * 90
    });
}
